export default __webpack_public_path__ + "static/media/pvilla3-3.95df7c97.jpg";